'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Controller } from 'react-hook-form';
import { FormControl } from '@mui/material';
import { FileErrorType } from '@application/enums/file-error-type';
import StyledFileUploader from '.';
import { useFileUploadOptional } from '../../contexts/FileUploadContext';
import { useState } from 'react';
function FileUploaderController({ name, control, rules, fileError: propFileError, setFileError: propSetFileError, fileUploaderProps }) {
    const contextValue = useFileUploadOptional();
    const [localFileError, setLocalFileError] = useState({
        hasError: false,
        errorType: FileErrorType.NoError
    });
    const fileError = contextValue?.fileError || propFileError || localFileError;
    const setFileError = contextValue?.setFileError || propSetFileError || setLocalFileError;
    const addAttachments = contextValue?.addAttachments;
    return (_jsx(Controller, { name: name, control: control, rules: {
            ...rules,
            validate: {
                ...(rules?.validate || {}),
                checkFileError: (files) => {
                    if (fileError.errorType === FileErrorType.CorruptedError && files.length > 0) {
                        return true;
                    }
                    return !fileError.hasError || 'File is corrupted, please choose a valid one.';
                }
            }
        }, render: ({ field: { onChange, value }, fieldState: { error } }) => (_jsx(FormControl, { variant: 'outlined', fullWidth: true, children: _jsx(StyledFileUploader, { ...fileUploaderProps, onChange: (files, title) => {
                    onChange(files);
                    fileUploaderProps.onChange?.(files, title);
                }, onFilesSubmitted: (files, title, type) => {
                    // Always call onFilesSubmitted if provided
                    if (fileUploaderProps.onFilesSubmitted) {
                        fileUploaderProps.onFilesSubmitted(files, title, type);
                    }
                    // Also call context addAttachments if available
                    if (addAttachments) {
                        addAttachments(files, title);
                        onChange([]);
                    }
                }, onValidationError: (hasError, errorType) => {
                    setFileError({ hasError, errorType });
                    fileUploaderProps.onValidationError?.(hasError, errorType);
                }, error: error?.message }) })) }));
}
export default FileUploaderController;
